import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { AllLevelsResponseModel, LevelDropDownResponseModel, LevelDto, LevelResponseModel } from '@gtpl/shared-models/masters';
import { Level } from './level.entity';
import { LevelAdapter } from './dto/level.adapter';
import { LevelDTO } from './dto/level.dto';
import { LevelRequest } from './dto/level.request';
import { LevelService } from './level.service';
import { LevelIdRequest } from './dto/level-id.request';


@ApiTags('level')
@Controller('level')
export class LevelController {

    constructor(
        private levelService: LevelService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      @Post('/createLevel')
      async createLevel(@Body() levelDto:LevelDTO,isUpdate:boolean=false,@Req() request:Request): Promise<LevelResponseModel> {
          try {
           return await this.levelService.createLevel(levelDto,false,request);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(LevelResponseModel, error);
         }
       }
  /**
   * 
   * @returns 
   */
      
  
      @Post('/getAllLevels')
      async getAllLevels(): Promise<AllLevelsResponseModel> {
          try {
              return await this.levelService.getAllLevels();
          } catch (error) {
              return this.applicationExceptionHandler.returnException(AllLevelsResponseModel, error);
          }
      }
  
       /**
       * Activate Or De-Activate Value Level
       * @param getSingleLevel LevelResponseModel 
       * @returns Value Level
       */
     @Post('/activateOrDeactivateLevel')
     async activateOrDeactivateLevel(@Body() levelReq: LevelRequest): Promise<LevelResponseModel> {
         try {
             return await this.levelService.activateOrDeactivateLevel(levelReq);
         } catch (err) {
             return this.applicationExceptionHandler.returnException(LevelResponseModel, err);
         }
     }
  
      /**
       * creates or updates a value of Level
       * @param LevelDto Level DTO
       * @returns LevelResponse
       */
       @Post('/updateLevel')
       async updateLevel(@Body() levelDto:LevelDTO,@Req() request:Request): Promise<LevelResponseModel> {
           try {
            return await this.levelService.createLevel(levelDto,true,request);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(LevelResponseModel, error);
          }
        }
       @Post('/getLevelByLevelId')
       async getLevelByLevelId(@Body() levelIdRequest:LevelIdRequest): Promise<LevelResponseModel> {
           try {
            return await this.levelService.getLevelByLevelId(levelIdRequest);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(LevelResponseModel, error);
          }
        }
        @Post('/getAllLevelDropDown')
        async getAllLevelDropDown(): Promise<LevelDropDownResponseModel> {
            try {
             return await this.levelService.getAllLevelDropDown();
           } catch (error) {
                return this.applicationExceptionHandler.returnException(LevelDropDownResponseModel, error);
           }
         }
    

}
